import moment from "moment";
import "moment-timezone";
import "moment/locale/ko";
import "moment/locale/ja";
import "moment/locale/es";
import "moment/locale/zh-cn";

moment.locale('ko');

let locale = "ko";
export const setLocale = (_locale) => {
    locale = _locale;
    moment.locale(_locale);
};

export const getLocale = () => {
    return locale;
};

export const getMomentDuration = (inp = 30, unit) => {
    if (unit) {
        return moment.duration(inp, unit);
    }
    return moment.duration(inp);
};

export const getMomentDate = (date, format) => {
    if (date && format) {
        if (format === "unix") {
            return moment.unix(date);
        } else if (format === "millisecond") {
            return moment.milliseconds(date);
        } else if (format === "utc") {
            return moment.utc(date);
        }
        return moment(date, format);
    } else if (date) {
        return moment(date);
    }

    return moment(new Date())
};

export const getTimezone = (moment_date, timezone = "Asia/Seoul") => {
    return moment_date.tz(timezone)
};

export const getDateString = (moment_date, format, locale = 'ko', timezone = "Asia/Seoul") => {
    if (format) {
        return getTimezone(moment_date, timezone).locale(locale).format(format);
    }

    return getTimezone(moment_date, timezone).locale(locale).format("YYYY-MM-DD HH:mm:ss");
};